import * as React from 'react';
import {FunctionComponent, useEffect, useRef} from 'react';

interface OwnProps {
    content: string;
}

/**
 * Hack around https://github.com/FormidableLabs/victory/issues/2391
 */
export const SvgText: FunctionComponent<OwnProps & React.SVGProps<SVGTextElement>> = ({content, ...props}) => {
    const ref = useRef<SVGTextElement>(null);

    useEffect(() => {
        const current = ref.current;
        if (current) {
            current.textContent = content;
        }
    }, [ref.current, content]);

    return <text ref={ref} {...props} />;
};
